@if (detail) {
    @if (showResultTile) {
        <app-detail-result-tile [operationDetail]="detail" />
    }

    @switch (detail?.operation_type_name) {
        @case (OPERATION_TYPE.OCR) {
            <app-operation-detail-tabs-details-ocr [detail]="detail" />
        }
        @case (OPERATION_TYPE.POL) {
            <app-operation-detail-tabs-details-pol [detail]="detail" />
        }
        @case (OPERATION_TYPE.DOCUMENTS) {
            <app-operation-detail-tabs-details-documents [detail]="detail" />
        }
        @case (OPERATION_TYPE.FORM) {
            <app-operation-detail-tabs-details-form [detail]="detail" />
        }
        @case (OPERATION_TYPE.CONNECTIONS) {
            <app-operation-detail-tabs-details-financial-evaluation [detail]="detail" />
        }
        @case (OPERATION_TYPE.EVALUATION) {
            <app-operation-detail-tabs-details-financial-evaluation [detail]="detail" />
        }
        @case (OPERATION_TYPE.FINANCIAL_EVALUATION) {
            <app-operation-detail-tabs-details-financial-evaluation [detail]="detail" />
        }
        @case (OPERATION_TYPE.BORME) {
            <app-operation-detail-tabs-details-borme [detail]="detail" />
        }
        @case (OPERATION_TYPE.TFA) {
            <app-operation-detail-tabs-details-messaging [detail]="detail" />
        }
        @case ('2FA') {
            <app-operation-detail-tabs-details-messaging [detail]="detail" />
        }
        @default {
            <tec-empty-state
                [title]="'OPERATIONS.DETAIL.TABS.DETAILS.UNSUPPORTED' | translate"
                [size]="'default'"
                [type]="'empty'"
            />
        }
    }
}
